(() => {
  function initialize(root = document) {
    root.querySelectorAll('.hc-contact__form').forEach((form) => {
      if (form.dataset.asyncReady) return;
      form.dataset.asyncReady = 'true';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (form.dataset.sending === 'true') return;
        const section = form.closest('.hc-contact');
        const english = section.lang === 'en';
        const button = form.querySelector('[type="submit"]');
        const label = button.querySelector('span');
        const originalLabel = label.textContent;
        form.dataset.sending = 'true';
        button.disabled = true;
        label.textContent = english ? 'Sending…' : 'جارٍ الإرسال…';
        form.querySelector('[data-send-error]')?.remove();
        try {
          const response = await fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            credentials: 'same-origin',
          });
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const result = html.querySelector('.hc-contact__success');
          if (response.ok && result) {
            const confirmation = document.importNode(result, true);
            confirmation.removeAttribute('autofocus');
            confirmation.removeAttribute('id');
            // Keep the form's height so replacing its fields cannot move the viewport.
            form.style.minHeight = form.getBoundingClientRect().height + 'px';
            form.style.alignContent = 'center';
            form.replaceChildren(confirmation);
            confirmation.focus({ preventScroll: true });
          } else {
            const error = document.createElement('div');
            error.className = 'hc-contact__errors';
            error.dataset.sendError = 'true';
            error.setAttribute('role', 'alert');
            const serverError = html.querySelector('.hc-contact__errors');
            if (serverError) {
              error.append(...Array.from(serverError.childNodes, node => document.importNode(node, true)));
            } else if (response.url.includes('/challenge')) {
              const link = document.createElement('a');
              link.href = response.url;
              link.textContent = english
                ? 'Complete Shopify’s security check to send your message.'
                : 'أكمل التحقق الأمني من Shopify لإرسال رسالتك.';
              error.append(link);
            } else {
              error.textContent = english
                ? 'Your message could not be confirmed. Please try again.'
                : 'تعذّر تأكيد إرسال رسالتك. يُرجى المحاولة مجدداً.';
            }
            form.append(error);
          }
        } catch {
          const error = document.createElement('p');
          error.className = 'hc-contact__errors';
          error.dataset.sendError = 'true';
          error.setAttribute('role', 'alert');
          error.textContent = english
            ? 'Please check your connection and try again.'
            : 'يُرجى التحقق من اتصالك بالإنترنت والمحاولة مجدداً.';
          form.append(error);
        } finally {
          form.dataset.sending = 'false';
          button.disabled = false;
          label.textContent = originalLabel;
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
